"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewAggregateSchema = exports.ProductReviewSchema = exports.AdminReplySchema = exports.ReviewStatusEnum = void 0;
const zod_1 = require("zod");
exports.ReviewStatusEnum = zod_1.z.enum(['pending', 'approved', 'rejected', 'hidden']);
exports.AdminReplySchema = zod_1.z.object({
    text: zod_1.z.string().min(1),
    repliedAt: zod_1.z.number(),
    repliedBy: zod_1.z.string(),
});
exports.ProductReviewSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    productId: zod_1.z.string(),
    reviewId: zod_1.z.string(),
    rating: zod_1.z.number().int().min(1).max(5),
    title: zod_1.z.string().max(120).optional().default(''),
    body: zod_1.z.string().min(1).max(4000),
    customerId: zod_1.z.string(),
    customerName: zod_1.z.string(),
    orderId: zod_1.z.string(),
    variantId: zod_1.z.string().optional(),
    status: exports.ReviewStatusEnum,
    adminReply: exports.AdminReplySchema.nullish(),
    createdAt: zod_1.z.number(),
    updatedAt: zod_1.z.number(),
});
exports.ReviewAggregateSchema = zod_1.z.object({
    avg: zod_1.z.number(),
    count: zod_1.z.number().int(),
    distribution: zod_1.z.tuple([zod_1.z.number(), zod_1.z.number(), zod_1.z.number(), zod_1.z.number(), zod_1.z.number()]),
});
//# sourceMappingURL=product-review.schema.js.map